import { Loader2 } from 'lucide-react';
import { Button } from './ui/button';

export function LoaderButton({
  isLoading,
  children,
  ...props
}: React.ComponentProps<typeof Button> & {
  isLoading: boolean;
}) {
  return (
    <Button disabled={isLoading || props.disabled} {...props}>
      {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : children}
    </Button>
  );
}
